// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TKfBVrQjqTc6HUJsTCB0{width:100%;padding:32px 0 24px}.PToNF23RRET0f9LFpbDm{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `TKfBVrQjqTc6HUJsTCB0`,
	"btn": `PToNF23RRET0f9LFpbDm`
};
export default ___CSS_LOADER_EXPORT___;
